import {SettingsService} from 'src/app/services/settings.service';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ToastController} from '@ionic/angular';
import {Network} from '@capacitor/network';
//import {TranslateService} from '@ngx-translate/core';
import {Storage} from '@ionic/storage-angular';


const STORAGE_REQ_KEY = 'storedreq';

export interface NetworkStatus {
  connected: boolean;
  connectionType: any;
}
export enum ConnectionStatus {
  Online,
  Offline
}

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  public status: BehaviorSubject<ConnectionStatus> = new BehaviorSubject(ConnectionStatus.Offline);

  constructor(
    public toastController: ToastController,
    //private translate: TranslateService,
    private settingsService: SettingsService,
    private storage: Storage
  ) {
    this.initializeNetworkEvents();
  }
  async initializeNetworkEvents() {
    const status = await Network.getStatus();

    // console.log('network status', status);
    if (status.connected) {
      this.status.next(ConnectionStatus.Online);
    } else {
      this.status.next(ConnectionStatus.Offline);
    }

    // check for network change
    const handler = Network.addListener('networkStatusChange', status => {
      // console.log('Network status changed', status);
      if (status.connected) {
        this.updateNetworkStatus(ConnectionStatus.Online);
      } else {
        this.updateNetworkStatus(ConnectionStatus.Offline);
      }
    });
  }

  private async updateNetworkStatus(status: ConnectionStatus) {
    if (status === ConnectionStatus.Online) {
      //CHECK IF SERVER AVAILABLE... THEN CHANGE STATUS!
      this.settingsService.isServerAvailable().subscribe(async res => {
        // console.log("server available: ",res)
        this.status.next(status);
        const connection = 'Online';
        console.log('Connection: ' + connection);
        /*const toast = await this.toastController.create({
          message: this.translate.instant('network.you_are') + ' ' + connection,
          duration: 3000,
          position: 'bottom'
        });
        toast.present();*/
      });
    } else {
      await this.storage.remove(STORAGE_REQ_KEY);
      this.status.next(status);
      const connection = 'Offline';
      /*const toast = await this.toastController.create({
        message: this.translate.instant('network.you_are') + ' ' + connection,
        duration: 3000,
        position: 'bottom'
      });
      toast.present();*/
      console.log('Connection: ' + connection);
    }
  }

  public onNetworkChange(): Observable<ConnectionStatus> {
    return this.status.asObservable();
  }

  public getCurrentNetworkStatus(): ConnectionStatus {
    return this.status.getValue();
  }
}
